import * as React from "react";
import { cn } from "../lib/utils";

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg" | "xxl";
  variant?: "default" | "primary" | "secondary";
  gifSrc?: string;
  fullscreen?: boolean;
}

const Loader = React.forwardRef<HTMLDivElement, LoaderProps>(
  ({ className, size = "md", variant = "default", gifSrc, fullscreen, ...props }, ref) => {
    const sizeClasses = {
      sm: "h-4 w-4",
      md: "h-8 w-8",
      lg: "h-12 w-12",
      xxl: "h-32 w-32",
    };

    const variantClasses = {
      default: "border-gray-300 border-t-gray-600",
      primary: "border-blue-200 border-t-blue-600",
      secondary: "border-gray-200 border-t-gray-800",
    };

    if (gifSrc) {
      return (
        <div
          ref={ref}
          className={cn(
            `flex items-center justify-center ${fullscreen ? "w-screen h-screen" : ""}`,
            className
          )}
          {...props}
        >
          <img src={gifSrc} alt="Loading" className={cn(sizeClasses[size])} />
        </div>
      );
    }

    return (
      <div ref={ref} className={cn("flex items-center justify-center", className)} {...props}>
        <div
          className={cn(
            "animate-spin rounded-full border-2 border-solid",
            sizeClasses[size],
            variantClasses[variant]
          )}
        />
      </div>
    );
  }
);

Loader.displayName = "Loader";

export { Loader };
